import React from 'react';


const Bugs = () => {
  return (
    <div>
      <h1>This is a Bug Solving Screen </h1>
    </div>
  )
}

export default Bugs
